// 第三方
import { action, observable, reaction, runInAction, configure } from "mobx";
// typings
import { TTimeModule, TCountdownModule } from "../../../services/playground";
import { TActState } from "../../../services/banner";
import { CountdownBannerMod } from "./index";

configure({ isolateGlobalState: true });
export class PCLitbCountdownStore {
	@observable state: TActState = TActState.OnGoing;
	@observable timer: TTimeModule;
	@observable countDown: number = 0;
	intervalId: NodeJS.Timeout;

	constructor(
		state: TActState,
		timer: TCountdownModule,
		refresh: () => Promise<CountdownBannerMod>,
	) {
		this.state = state;
		this.timer = timer?.time;

		reaction(
			() => this.state,
			(state: TActState) => {
				clearInterval(this.intervalId);
				if ([TActState.OnGoing, TActState.ComingSoon].includes(state)) {
					this.countDown = parseInt(timer?.time?.left || "0", 10);
					this.intervalId = setInterval(async () => {
						if (this.countDown <= 0) {
							clearInterval(this.intervalId);
							await this.refreshModule(refresh);
							return;
						}
						runInAction("tick", () => {
							this.countDown = this.countDown - 1;
						});
					}, 1000);
				}
			},
			{ fireImmediately: true },
		);
	}

	@action
	refreshModule = async (refresh: () => Promise<CountdownBannerMod>) => {
		const result = await refresh();
		if (result) {
			runInAction("refresh module", () => {
				this.state = result.actState;
				this.timer = result.timer?.time;
				this.countDown = parseInt(result.timer?.time?.left || "0", 10);
			});
		}
	};
}
